import estilos from "./SobreMim.module.css";

const SobreMim = () => {
  return (
    <section id="sobre" className={estilos.secao}>
      <span className={estilos.etiqueta}>// Sobre Mim</span>
      <h2 className={estilos.titulo}>Quem sou eu</h2>

      <p className={estilos.texto}>
        Comecei minha jornada na programação cedo, motivado pela curiosidade em entender como sistemas funcionam por trás das interfaces. Hoje, com 18 anos, curso{" "}
        <span className={estilos.destaque}>Ciência da Computação na Unifenas</span> e já acumulei mais de{" "}
        <span className={estilos.destaque}>700 horas de formação na Itera 360</span>, onde aprofundei conhecimentos em desenvolvimento de software com projetos reais.
      </p>

      <p className={estilos.texto}>
        Minha evolução natural me levou ao <span className={estilos.destaque}>backend</span> — onde encontrei minha vocação em construir APIs robustas, implementar arquiteturas limpas e estruturar sistemas que realmente funcionam em produção.
      </p>

      <p className={estilos.texto}>
        Hoje meu foco está em <span className={estilos.destaque}>arquitetura de software</span>, padrões de projeto, separação de responsabilidades e construção de soluções escaláveis com C# e .NET.
      </p>

      <div className={estilos.infos}>
        <div className={estilos.infoCard}>
          <p className={estilos.infoTitulo}>Formação</p>
          <p className={estilos.infoValor}>Ciência da Computação – Unifenas</p>
        </div>
        <div className={estilos.infoCard}>
          <p className={estilos.infoTitulo}>Complementar</p>
          <p className={estilos.infoValor}>Itera 360 — 700h</p>
        </div>
        <div className={estilos.infoCard}>
          <p className={estilos.infoTitulo}>Foco</p>
          <p className={estilos.infoValor}>Backend & Arquitetura</p>
        </div>
      </div>
    </section>
  );
};

export default SobreMim;
